import cx from 'classnames'
import Downshift from 'downshift'
import * as React from 'react'

import { angleDown, angleUp, times } from '../../icons/index'
import type { ShowFromListViewModel } from '../../view-models/ShowFromListViewModel'
import Button from '../_legacy/Button'
import Icon from '../Icon/Icon'
import MediaQuery from '../MediaQuery/MediaQuery'
import Select from '../Select/Select'
import styles from './dropshiftDropdown-style.css'
import useMedia from '@charlietango/use-media'

export type DropshiftDropdownProps = {
  items: ShowFromListViewModel[]
  itemToString: (item: Record<string, any>) => string
  placeholder?: string
  onChange: (...args: any[]) => any
  onFocus: (...args: any[]) => any
  onOuterClick: (...args: any[]) => any
  onStateChange?: (...args: any[]) => void
  id: string
  mobileId: string
  isOpen?: boolean //TODO: Check if this prop should really be added! It is passed down by `ShowChosenFromList`.
}

function DropshiftDropdown({
  itemToString,
  items,
  placeholder,
  onChange,
  onFocus,
  onOuterClick,
  id,
  mobileId,
  ...rest
}: DropshiftDropdownProps) {
  return (
    <div className={styles.dropshiftDropdown} id={id}>
      <MediaQuery defaultMatches={true} query={'(min-width: 769px)'}>
        {(matches) =>
          matches ? (
            <Downshift
              itemToString={itemToString}
              {...rest}
              id={'downshift-2-label'}
              onOuterClick={onOuterClick}
            >
              {({
                getInputProps,
                getToggleButtonProps,
                getItemProps,
                isOpen,
                clearSelection,
                selectedItem,
                highlightedIndex,
              }) => (
                <div
                  className={cx(
                    styles.dropshiftWrapper,
                    isOpen ? styles.active : '',
                  )}
                >
                  <div className={styles.dropshiftInputWrapper}>
                    {placeholder && (
                      <input
                        {...getInputProps({
                          placeholder,
                        })}
                        className={styles.dropShiftInput}
                        onFocus={onFocus}
                      />
                    )}
                    <div className={styles.dropshiftBtns}>
                      {selectedItem ? (
                        <button
                          className={cx(styles.clearSelection, styles.btn)}
                          onClick={() => clearSelection()}
                        >
                          <Icon
                            iconSrc={times}
                            height={'15px'}
                            width={'15px'}
                          />
                        </button>
                      ) : (
                        <button
                          className={cx(styles.clearSelection, styles.btn)}
                          {...getToggleButtonProps()}
                        >
                          <Icon
                            width={'12px'}
                            height={'18px'}
                            iconSrc={!isOpen ? angleDown : angleUp}
                          />
                        </button>
                      )}
                    </div>
                  </div>
                  {!isOpen ? null : (
                    <ul className={styles.dropshiftResults}>
                      {items.map((item, index) => (
                        <li
                          id={item.keypair.key}
                          className={styles.resultItems}
                          key={item.keypair.key}
                          {...getItemProps({
                            item,
                            index,
                          })}
                          style={{
                            backgroundColor:
                              highlightedIndex === index ? '#e6e6e6' : '',
                            fontWeight: selectedItem === item ? 'normal' : '',
                          }}
                        >
                          {item.keypair.value}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </Downshift>
          ) : (
            <Select
              items={items}
              placeholder={placeholder}
              onChange={onChange}
              id={mobileId}
              defaultValue=""
            />
          )
        }
      </MediaQuery>
    </div>
  )
}

DropshiftDropdown.displayName = 'DropshiftDropdown'
DropshiftDropdown.defaultProps = {}
export default DropshiftDropdown
